import React from 'react';
import './style.scss';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const CustomTextFieldHelperText = ({
  text,
  limit = null,
  value = null,
  disabled = false,
  valid = true,
}) => {
  if ((!text && (!limit || limit <= 0)) || disabled) return null;

  const className = (() => {
    if (text && limit > 0) return 'ctf-ht-between';
    if (text) return 'ctf-ht-left';
    return 'ctf-ht-right';
  })();

  return (
    <div
      className={clsx(
        'ctf-helper-text',
        disabled && 'ctf-helper-text-disabled',
        !valid && 'ctf-helper-text-invalid',
        className
      )}
    >
      {text && <p>{text}</p>}
      {limit > 0 && (
        <p>
          {value?.length || 0}/{limit}
        </p>
      )}
    </div>
  );
};

CustomTextFieldHelperText.propTypes = {
  text: PropTypes.string,
  limit: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  valid: PropTypes.bool,
};

export default CustomTextFieldHelperText;
